import { createContext } from 'react';

import type { ThemeProviderState } from './theme.provider';

const initialState: ThemeProviderState = {
  theme: 'system',
  setTheme: () => undefined,
};

export const ThemeProviderContext = createContext<ThemeProviderState>(initialState);
